/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Broker_UnpairedInputs */

const cs_ebr_broker_unpaired = /** @type {(inputs: Ebr_Broker_UnpairedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nespárováno`)
};

const en_ebr_broker_unpaired = /** @type {(inputs: Ebr_Broker_UnpairedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unpaired`)
};

/**
* | output |
* | --- |
* | "Unpaired" |
*
* @param {Ebr_Broker_UnpairedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_broker_unpaired = /** @type {((inputs?: Ebr_Broker_UnpairedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Broker_UnpairedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_broker_unpaired(inputs)
	return cs_ebr_broker_unpaired(inputs)
});